import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Form, Input, Icon } from 'semantic-ui-react';
import styled from 'styled-components';
import Svg from 'react-inlinesvg';
import { breakpoints } from '../../styles';
import { Select } from '../FormComponents/';
import { searchIcon } from '../../images';
import { objectKeysToLowerCase } from '../../utils/helpers';

const StyledSelect = styled(Select)`
  @media screen and (min-width: ${breakpoints.computer}) {
    max-width: 30%;
  }
`;

const FilterBar = ({
  handleBrandChange,
  selectedBrand,
  brands: rawBrands,
  handleSearchInput
}) => {
  // there are discrepencies between the casing patterns of the brands depending
  // on their origin. We must ensure uniformity
  const brands = rawBrands.map(brand => objectKeysToLowerCase(brand));
  const sortedBrands = brands.sort((a, b) =>
    a.name.toString().localeCompare(b.name, undefined, { sensitivity: 'base' })
  );

  useEffect(() => {
    // if only one brand, set it to the default brand as the
    // dropdown will be removed from the UI
    if (brands.length === 1) handleBrandChange(brands[0].name);
  }, [rawBrands]);

  return (
    <Form>
      <div className="bg--secondary">
        <Form.Group className="fields--fluid">
          {brands.length > 1 && (
            <StyledSelect
              field={{ name: 'brand_select', value: selectedBrand }}
              label="Brands"
              placeholder="All Brands"
              options={sortedBrands.map(brand => ({
                value: brand.name,
                text: brand.name
              }))}
              onChange={e => handleBrandChange(e.target.value)}
              placeholderDisabled={false}
              data-test="asset-brand-filter"
              isStatic
            />
          )}
          {/* TODO: use static version of input field */}
          <Form.Field>
            <Input
              placeholder="Filter results with any keyword"
              onChange={handleSearchInput}
              iconPosition="left"
              icon={
                <Icon>
                  <Svg src={searchIcon} />
                </Icon>
              }
              size="large"
              data-test="asset-search-filter"
            />
          </Form.Field>
        </Form.Group>
      </div>
    </Form>
  );
};

FilterBar.defaultProps = {
  selectedBrand: ''
};

FilterBar.propTypes = {
  handleBrandChange: PropTypes.func.isRequired,
  selectedBrand: PropTypes.string,
  brands: PropTypes.arrayOf(PropTypes.object).isRequired,
  handleSearchInput: PropTypes.func.isRequired
};

export default FilterBar;
